import './App.css';
import { ChakraProvider } from '@chakra-ui/react'
import { extendTheme } from "@chakra-ui/react"
import LandingPage from './components/LandingPage/LandingPage.jsx'

const outlineBtn={
	borderRadius:'55px',
	marginTop: "15px",
	paddingTop:"0px",
	paddingBottom: "0px",
	paddingRight: "30px",
	paddingLeft: "30px",
	height:"36px",
	color:'#bcbcbc',
	borderColor: '#bcbcbc',
	fontSize:'90%',
	fontFamily: "Barlow Condensed Regular",
	borderWidth:'1px',
	width:'100%',
	transition: 'all 300ms linear'

}
const theme = extendTheme({
	components:{
		Button: {
			variants: {
				outlineYellow: {
					...outlineBtn,
					_hover:{
						animation: 'unset',
						bg: '#402000',
						color: '#ff7f00',
						borderColor: '#ff7f00'
					}
				},
				outlineBlue: {
					...outlineBtn,
					_hover:{
						animation: 'unset',
						bg: '#004040',
						color: '#00ffff',
						borderColor: '#00ffff'
					}
				},
				outlineYellowAnimated: {
					...outlineBtn,
					animation: 'pulse-yellow 4s infinite',
					_hover:{
						animation: 'unset',
						bg: '#402000',
						color: '#ff7f00',
						borderColor: '#ff7f00'
					}
				},
				outlineBlueAnimated: {
					...outlineBtn,
					animation: 'pulse-blue 4s infinite',
					_hover:{
						animation: 'unset',
						bg: '#004040',
						color: '#00ffff',
						borderColor: '#00ffff'
					}
				}

			}
		}
	}
})

function App() {
	return (
		<ChakraProvider theme={theme}>
		<div className="App">
			<LandingPage />
		</div>
		</ChakraProvider>
	);
}

export default App;
